import type { CSS } from '@stitches/react';

import {
  IToggleProps,
  ToggleHeader,
  ToggleHeaderIconPosition,
  ToggleHeaderSize,
  ToggleHeaderVariant,
} from '@/components/shared/data-display/toggle-header';
import { Box } from '@/components/shared/layout/box';
import { styled } from '@/stitches.config';

const ToggleCompareBody = styled(Box, {
  variants: {
    variant: {
      gray: {},
      white: {},
      transparent: {},
    },
    isOpen: {
      true: {},
    },
    isDisable: {
      true: {},
      false: {},
    },
    isLine: {
      true: {
        borderBottom: '1px solid $gray300',
      },
    },
  },
  compoundVariants: [
    {
      isOpen: true,
      variant: 'gray',
      css: {
        backgroundColor: '$gray200',
      },
    },
    {
      isOpen: true,
      variant: 'white',
      css: {
        backgroundColor: '$white',
      },
    },
    {
      isDisable: true,
      variant: 'transparent',
      css: {
        px: '$space-0',
      },
    },
  ],
});

interface IProps extends IToggleProps {
  title: string;
  isOpen: boolean;
  onToggle: (value: boolean) => void;
  variant?: ToggleHeaderVariant;
  size?: ToggleHeaderSize;
  isDisable?: boolean;
  isLine?: boolean;
  iconPosition?: ToggleHeaderIconPosition;
  children?: React.ReactNode;
  dataTest?: string;
  css?: CSS;
}

export const Toggle: React.FC<IProps> = ({
  title,
  isOpen,
  onToggle,
  size,
  isDisable,
  isLine,
  children,
  dataTest,
  css,
  iconPosition = 'trailing',
  variant = 'gray',
}) => {
  const _onClick = () => {
    !isDisable && onToggle(!isOpen);
  };
  return (
    <>
      <Box
        css={css}
        rounded="1"
        overflow="hidden"
        test={{
          dataTest: dataTest,
        }}
      >
        <ToggleHeader
          title={title}
          size={size}
          variant={variant}
          isOpen={isOpen}
          isDisable={isDisable}
          isLine={isLine}
          iconPosition={iconPosition}
          onClick={_onClick}
          dataTest={dataTest}
        />
        {!!isOpen && (
          <ToggleCompareBody
            padding="4"
            className="toggle-body"
            variant={variant}
            isOpen={isOpen}
            isDisable={isDisable}
            isLine={isLine}
            test={{
              dataTest: 'toggle_body',
            }}
          >
            {children}
          </ToggleCompareBody>
        )}
      </Box>
    </>
  );
};
Toggle.displayName = 'Toggle';
